
import { useNavigate } from 'react-router-dom';
import styles from './JoinBanner.module.css';

export default function JoinBanner() {
  const navigate = useNavigate();

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.left}>
          <div className={styles.logo}>
            <svg viewBox="0 0 48 48" fill="none" width="28" height="28">
              <path d="M8 36L20 14L32 36" stroke="#016d9c" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M20 14L32 36L40 20" stroke="#fb9833" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className={styles.logoText}>NES<span>S</span>EFY</span>
          </div>
          <p className={styles.tagline}>
            Join the network where ambition meets opportunity.
          </p>
        </div>

        <div className={styles.actions}>
          <button
            className={styles.loginBtn}
            onClick={() => navigate('/login')}
          >
            Log in
          </button>
          <button
            className={styles.joinBtn}
            onClick={() => navigate('/register')}
          >
            Join Nessefy — it's free
          </button>
        </div>
      </div>
    </div>
  );
}